import { KYMW4701Model } from '../kymw4701.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

export type GetCandidateGoodsResponse = {
  CandidateGoodsList: {
    MultiCode: string;
    PublishSeq: string;
    PCode: string;
    ApplyTermEnd: string;
    GuideGoodsName: string;
    GuideStandardName: string;
    MakerName: string;
    PayeeClient: string;
    RegistDate: string;
  }[];
};

/**
 * 候補商品情報取得
 *
 * @export API通信成功時の処理
 * @class GetCandidateGoodsService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetCandidateGoodsService extends PlessJsonResponderSub<GetCandidateGoodsResponse> {
  // 処理に使用するModel
  private model: KYMW4701Model = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCandidateGoodsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        GuideGoodsName: this.model.searchingGoodsName,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW4701Model} model
   * @param {Function} [successFunc] 成功時後続処理
   * @memberof GetCandidateGoodsService
   */
  execute(model: KYMW4701Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getCandidateGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCandidateGoodsService
   */
  success(data: GetCandidateGoodsResponse) {
    if (data) this.model.setCandidateGoodsData(data);
    if (this.successFunc) this.successFunc();
  }
}
